<template>
  <div class="select form-status">
    <select class="select2 item-status" :value="estadoorigen" style="width:100%" data-select2-container="item-status-cont" ref="slEstados">
      <option :value="estadoorigen" :data-class="getClassInicial()">{{getTextInicial()}}</option>
      <option v-for="estado in estadosDisponibles" :data-class="estado.class" :value="estado.id">{{estado.text}}</option>
    </select>
  </div>
</template>
<script>
  import './../../assets/css/select2.css'
  import './../../assets/css/select2_status.css'
  import $ from 'jquery'
  import 'select2'
  export default {
    props: ['estadoorigen', 'identrega'],
    computed: {
      estadosDisponibles () {
        const me = this
        let estadosPosibles = me.estadosHacia[me.estadoorigen]
        let estadosFiltrados = me.estados.filter((est) => {
          return estadosPosibles.includes(est.id)
        })
        return estadosFiltrados
      },
      estadoOrigenObj () {
        const me = this
        let estado = me.estados.find((est) => {
          return est.id === me.estadoorigen
        })
        return estado
      }
    },
    methods: {
      format (itemstatus) {
        if (!itemstatus.id) {
          return itemstatus.text
        }
        let id = itemstatus.element.attributes['data-class'].value
        let text = itemstatus.text
        return `<span class="highlight-status status-is-${id}">${text}</span>`
      },
      getClassInicial () {
        const me = this
        return me.estadoOrigenObj.class
      },
      getTextInicial () {
        return this.estadoOrigenObj.text
      }
    },
    data () {
      return {
        estadosHacia: {
          Recibido: ['Cocina', 'Cancelado'],
          Cocina: ['Empaquetado', 'Cancelado', 'Recibido'],
          Empaquetado: ['Despachado', 'Cancelado', 'Cocina'],
          Despachado: ['']
        },
        estados: [
          {text: 'Pendiente', id: 'Recibido', class: 'pending'},
          {text: 'En curso', id: 'Cocina', class: 'oncourse'},
          {text: 'Procesado', id: 'Empaquetado', class: 'process'},
          {text: 'Despachado', id: 'Despachado', class: 'payment-pending'},
          {text: 'Cancelado', id: 'Cancelado', class: 'canceled'}
        ]
      }
    },
    mounted () {
      const me = this
      const $select = $(this.$refs.slEstados)
      $select.select2({
        templateResult: me.format,
        templateSelection: me.format,
        // placeholder: 'Seleccionar',
        escapeMarkup: (m) => {
          return m
        },
        minimumResultsForSearch: -1
      }).on('change', (e) => {
        me.$emit('change-estado', {
          estado: e.target.value,
          entrega: me.identrega
        })
      })
    }
  }
</script>



// WEBPACK FOOTER //
// ComboEstados.vue?5c2ad3f4